export const paginationItemsOnPage = [50, 100, 200, 500];
